import { Component, Input, OnInit } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

@Component({
    selector: 'pr-question',
    templateUrl: './pr-question.component.html',
    styleUrls: ['./pr-question.component.scss'],
    standalone: false
})
export class PrQuestionComponent implements OnInit {
  @Input() question: any;
  answerDisplay: boolean = true;

  constructor(public breakpointObserver: BreakpointObserver) {}

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 800px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.answerDisplay = false;
        } else {
          this.answerDisplay = true;
        }
      });
  }
}
